// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"T_nS4"};